const middlewaresErrorsHandler = (error, getState, action) => {
    if (typeof action === 'object' && !!action.type) {
        if (!window.newrelic) {
            const state = getState();
            window.console.error('prev state --> ', state);
            window.console.error('action --> ', action);
        } else {
            error.message = `${error.message}\n--> action: ${action.type}`;
        }
    }
    throw error;
};

export default {
    middlewaresErrorsHandler,
};
